module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-latin25.9526470.woff2";